import React, { useEffect, useState } from "react";
import {
  Nav,
  NavItem,
  TabContent,
  TabPane,
  NavLink,
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  FormGroup,
  Label,
  Input,
  Button,
  FormFeedback,
  Form,
} from "reactstrap";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { SuccessNotify, ErrorNotify } from "../../shared/Alert";
import * as url from "../../helpers/url_helper";
import { showLoading } from "react-global-loading";

import { getData, postData, postRawData } from "../../helpers/url-request";
import { getCompanyDetails } from "../../helpers/backend_helper";

import classnames from "classnames";
import Location from "../Settings/Location";
import CompanySelectionList from "./CompanySelectionList";
import FirmAuthenticationSettings from "./FirmAuthenticationSettings";

const CompanyFullDetail = (props) => {
  const [activeTab, setactiveTab] = useState(1);

  const [formData, setFormData] = useState({
    id: 0,
    name: "",
    address: "",
    contactNo: "",
    emailId: "",
    website: "",
  });

  useEffect(() => {
    if (props.companyId && props.companyId > 0) {
      showLoading(true);
      getCompanyDetails(props.companyId).then((res) => {
        showLoading(false);
        if (res.status) {
          setFormData((formData) => ({
            ...formData,
            id: res.data.id,
            name: res.data.name,
            address: res.data.address,
            contactNo: res.data.contactNo,
            emailId: res.data.emailId,
            website: res.data.website,
          }));
        } else {
          ErrorNotify(res.message);
        }
      });
    }
  }, []);

  // Form validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      id: props.companyId || 0,
      name: formData.name || "",
      address: formData.address || "",
      emailId: formData.emailId || "",
      contactNo: formData.contactNo || "",
      website: formData.website || "",
    },
    onSubmit: async (values) => {
      var _data = {
        id: values.id,
        name: values.name,
        address: values.address,
        emailId: values.emailId,
        contactNo: values.contactNo,
        website: values.website,
      };

      showLoading(true);

      postData("/company/addupdate", _data)
        .then((res) => {
          showLoading(false);
          if (res.status == true) {
            SuccessNotify("Data saved successfully");

            if (props.closeAction) props.closeAction();
          } else {
            ErrorNotify(res.message);
          }
        })
        .catch((err) => {
          console.log(err);
          showLoading(false);
          ErrorNotify("Error occured while saving data");
        });
    },
  });

  return (
    <React.Fragment>
      <Row>
        <Col xl={4}>
          <CardBody>
            <Form
              className="needs-validation"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <Row>
                <Col sm="12" className="mb-1">
                  <FormGroup className="mb-3">
                    <Label htmlFor="validationCustom03">Name</Label>
                    <Input
                      name="name"
                      type="text"
                      placeholder="Department Name"
                      className="form-control"
                      id="validationCustom03"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.name || ""}
                      invalid={
                        validation.touched.name && validation.errors.name
                          ? true
                          : false
                      }
                    />
                    {validation.touched.name && validation.errors.name ? (
                      <FormFeedback type="invalid">
                        {validation.errors.name}
                      </FormFeedback>
                    ) : null}
                  </FormGroup>
                </Col>

                <Col sm="12" className="mb-1">
                  <FormGroup className="mb-3">
                    <Label>Address</Label>
                    <Input
                      name="address"
                      type="textarea"
                      rows="3"
                      placeholder="Address"
                      className="form-control"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.address || ""}
                      invalid={
                        validation.touched.address && validation.errors.address
                          ? true
                          : false
                      }
                    />
                    {validation.touched.address && validation.errors.address ? (
                      <FormFeedback type="invalid">
                        {validation.errors.address}
                      </FormFeedback>
                    ) : null}
                  </FormGroup>
                </Col>

                <Col sm="12" className="mb-1">
                  <FormGroup className="mb-3">
                    <Label>Contact No</Label>
                    <Input
                      name="contactNo"
                      type="text"
                      placeholder="Contact No."
                      className="form-control"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.contactNo || ""}
                      invalid={
                        validation.touched.contactNo &&
                        validation.errors.contactNo
                          ? true
                          : false
                      }
                    />
                    {validation.touched.contactNo &&
                    validation.errors.contactNo ? (
                      <FormFeedback type="invalid">
                        {validation.errors.contactNo}
                      </FormFeedback>
                    ) : null}
                  </FormGroup>
                </Col>

                <Col sm="12" className="mb-1">
                  <FormGroup className="mb-3">
                    <Label>Email Id</Label>
                    <Input
                      name="emailId"
                      type="text"
                      placeholder="Email Id"
                      className="form-control"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.emailId || ""}
                      invalid={
                        validation.touched.emailId && validation.errors.emailId
                          ? true
                          : false
                      }
                    />
                    {validation.touched.emailId && validation.errors.emailId ? (
                      <FormFeedback type="invalid">
                        {validation.errors.emailId}
                      </FormFeedback>
                    ) : null}
                  </FormGroup>
                </Col>

                <Col sm="12" className="mb-1">
                  <FormGroup className="mb-3">
                    <Label>Website</Label>
                    <Input
                      name="website"
                      type="text"
                      placeholder="Website"
                      className="form-control"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.website || ""}
                      invalid={
                        validation.touched.website && validation.errors.website
                          ? true
                          : false
                      }
                    />
                    {validation.touched.website && validation.errors.website ? (
                      <FormFeedback type="invalid">
                        {validation.errors.website}
                      </FormFeedback>
                    ) : null}
                  </FormGroup>
                </Col>
              </Row>
              <div className="mt-2">
                <Button className="btn btn-success me-4" type="submit">
                  Submit
                </Button>
                <Button
                  className="btn btn-light"
                  color="secondary"
                  type="button"
                  onClick={props.closeAction}
                >
                  Close
                </Button>
              </div>
            </Form>
          </CardBody>
        </Col>
        <Col xl={8}>
          <Nav tabs>
            <NavItem>
              <NavLink
                href="#"
                className={classnames({ active: activeTab === 1 })}
                onClick={() => {
                  setactiveTab(1);
                }}
              >
                <span className="me-2">Branches</span>
                <span class="badge text-bg-info">0</span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                href="#"
                className={classnames({ active: activeTab === 2 })}
                onClick={() => setactiveTab(2)}
              >
                <span className="me-2">Authentication &amp; SSO</span>
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent className="" activeTab={activeTab}>
            <TabPane tabId={1}>
              <Location companyId={props.companyId} />
            </TabPane>
            <TabPane tabId={2}>
              <FirmAuthenticationSettings firmId={props.companyId} />
            </TabPane>
          </TabContent>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default CompanyFullDetail;
